import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { addDirectionaryItem, getLibraryDetail } from './request.js';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dictionaryRecord: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible(newval) {
      if (newval) {
        //获取已设置的值
        getLibraryDetail({
          id: this.dictionaryRecord.id
        }).then(res => {
          this.addForm.name = res.name;
          this.addForm.code = res.code;
          this.addForm.field_category = res.field_category;
          let expand = res.expand && JSON.parse(res.expand);
          let dictionaryData = expand && Array.isArray(expand) ? expand : [];
          if (dictionaryData && dictionaryData.length > 0) {
            this.dictionaryData = dictionaryData;
            this.errorCell = {};
            dictionaryData.forEach((item, index) => {
              this.$set(this.errorCell, 'value' + index, false);
              this.$set(this.errorCell, 'key' + index, false);
            });
          }
        });
      } else {
        this.addForm.name = '';
        this.addForm.code = '';
        this.addForm.field_category = '';
        this.dictionaryData = [{
          key: '',
          value: ''
        }];
        this.errorCell = {
          value0: false,
          key0: false
        };
      }
    }
  },
  data() {
    return {
      dictionaryColumns: [{
        slots: {
          title: '字典值'
        },
        dataIndex: 'value',
        key: 'value',
        align: 'center',
        scopedSlots: {
          customRender: 'value'
        }
      }, {
        slots: {
          title: '值标识'
        },
        dataIndex: 'key',
        key: 'key',
        align: 'center',
        scopedSlots: {
          customRender: 'key'
        }
      }, {
        slots: {
          title: ''
        },
        key: '7',
        align: 'center',
        width: 130,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      classList: [],
      addForm: {
        name: '123',
        code: '456',
        field_category: '4554'
      },
      saveLoading: false,
      dictionaryData: [{
        key: '',
        value: ''
      }],
      errorCell: {
        value0: false,
        key0: false
      }
    };
  },
  computed: {
    addRules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('字段名称'),
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: this.$t('至少输入2个字符,最多输入20个字符'),
          trigger: 'blur'
        }],
        field_category: [{
          required: true,
          message: this.$t('请选择') + this.$t('字段分类'),
          trigger: 'change'
        }],
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('字段代码'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    saveAdd() {
      this.$refs['addFormRef'].validate(valid => {
        if (valid) {
          let checkPass = this.checkNull();
          if (!checkPass) {
            this.$message.error(this.$t('请填写完整'));
            return;
          }
          let repeatKeyMap = {};
          let repeatValueMap = {};
          this.dictionaryData.forEach(item => {
            //收集key和value的重复次数
            if (!repeatKeyMap[item.key]) {
              repeatKeyMap[item.key] = 1;
            } else {
              repeatKeyMap[item.key] = repeatKeyMap[item.key] + 1;
            }
            if (!repeatValueMap[item.value]) {
              repeatValueMap[item.value] = 1;
            } else {
              repeatValueMap[item.value] = repeatValueMap[item.value] + 1;
            }
          });
          this.dictionaryData.forEach((item, index) => {
            //校验是否有重复的值 有的话提示
            if (repeatKeyMap[item.key] > 1) {
              this.$set(this.errorCell, 'key' + index, true);
            } else {
              this.$set(this.errorCell, 'key' + index, false);
            }
            if (repeatValueMap[item.value] > 1) {
              this.$set(this.errorCell, 'value' + index, true);
            } else {
              this.$set(this.errorCell, 'value' + index, false);
            }
          });
          //判断是否有重复的值
          if (Object.keys(repeatKeyMap).length !== this.dictionaryData.length || Object.keys(repeatValueMap).length !== this.dictionaryData.length) {
            this.$message.error(this.$t('字段值下数据重复/值标识下数据重复'));
            return;
          }
          this.dictionaryData.forEach(item => {
            item.key = String(item.key);
          });
          let params = {
            id: this.dictionaryRecord.id,
            expand: JSON.stringify(this.dictionaryData)
          };
          addDirectionaryItem(params).then(res => {
            if (res.id) {
              this.$message.success(this.$t('保存成功'));
              this.$emit('update:visible', false);
            }
          });
        }
      });
    },
    checkNull() {
      let checkPass = true;
      this.dictionaryData.forEach((item, index) => {
        if (!item.value) {
          checkPass = false;
          this.errorCell['value' + index] = true;
        } else {
          this.errorCell['value' + index] = false;
        }
        if (!item.key) {
          checkPass = false;
          this.errorCell['key' + index] = true;
        } else {
          this.errorCell['key' + index] = false;
        }
      });
      return checkPass;
    },
    addLine() {
      let checkPass = this.checkNull();
      //添加行前判断是否有空值
      if (checkPass) {
        this.dictionaryData.push({
          key: '',
          value: ''
        });
        let index = this.dictionaryData.length - 1;
        this.$set(this.errorCell, 'value' + index, false);
        this.$set(this.errorCell, 'key' + index, false);
      } else {
        this.$message.error(this.$t('请填写完整'));
      }
    },
    deleteLine(index) {
      this.dictionaryData.splice(index, 1);
      delete this.errorCell['value' + index];
      delete this.errorCell['key' + index];
    },
    changeInputValue(e, key) {
      //输入框值改变时，如果有错误提示，清除错误提示
      // if (e.target.value && this.errorCell[key]) {
      //   this.errorCell[key] = false;
      // }
    },
    closeAddVisible() {
      this.$emit('update:visible', false);
    }
  }
};